import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { USER_TYPE } from "src/constant";
import useQueryParams from "src/hooks/useQueryParams";
import useEmployeeList from "src/hooks/user/useEmployeeList";
import { v4 as uuid } from "uuid";

const ROLE_NAME_VI = {
  SuperAdmin: "Tổng Quản lý Kho",
  AdminAccountant: "Admin kế toán",
  AdminFactory: "Admin kho xưởng",
  ManagerFactory: "Manager kho xưởng",
  StaffFactory: "Nhân viên kho xưởng",
  AdminWarehouse: "Admin kho bán hàng",
  ManagerWarehouse: "Manager kho bán hàng",
  StaffWarehouse: "Nhân viên kho bán hàng",
};

const ROLE_CODE_VI = {
  superadmin: "Tổng Quản lý Kho",
  adminaccountant: "Admin kế toán",
  adminfactory: "Admin kho xưởng",
  managerfactory: "Manager kho xưởng",
  stafffactory: "Nhân viên kho xưởng",
  adminwarehouse: "Admin kho bán hàng",
  managerwarehouse: "Manager kho bán hàng",
  staffwarehouse: "Nhân viên kho bán hàng",
};

const USER_TYPE_VI = {
  Staff: "Nhân viên Kho/Kế toán",
  Sales: "Nhân viên Kinh doanh",
  SalesChannel: "Nhân viên kinh doanh",
};

const getRoleDisplayName = (role) => {
  if (!role) return "";
  return ROLE_NAME_VI[role.name] ?? ROLE_CODE_VI[role.code?.toLowerCase()] ?? role.name ?? "";
};

const getTypeDisplayName = (user) => {
  const roleLabel = getRoleDisplayName(user?.role);
  if (roleLabel) return roleLabel;
  return USER_TYPE_VI[user?.type] ?? ROLE_NAME_VI[user?.type] ?? ROLE_CODE_VI[user?.type?.toLowerCase()] ?? user?.type ?? "";
};

export default function useCustomerBody({ keyword, paramsQuery, userWarehouseId }) {
  const [option] = useQueryParams();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });

  const { warehouse: warehouseFromFilter, ...paramsWithoutWarehouse } = paramsQuery || {};
  const warehouseParam = warehouseFromFilter ?? userWarehouseId;

  const {
    data: customers,
    isLoading,
    error,
  } = useEmployeeList({
    ...pagi,
    sortField: "sortName",
    sortOrder: "asc",
    // searchField: "fullName",
    // searchValue: !!keyword ? keyword : undefined,
    ...paramsWithoutWarehouse,
    type: USER_TYPE[option?.tab] === USER_TYPE.SalesChannel ? undefined : USER_TYPE[option?.tab],
    q: !!keyword ? keyword : undefined,
    ...(warehouseParam ? { warehouse: warehouseParam } : {}),
  });
  const isSalesTab = option.tab === USER_TYPE.Sales;

  const header = [
    {
      id: uuid(),
      title: "STT",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tên",
      width: "220px",
      align: "center",
    },
    isSalesTab
      ? null
      : {
          id: uuid(),
          title: "Kho - Vai trò",
          width: "260px",
          align: "center",
        },
    {
      id: uuid(),
      title: "SĐT - Email",
      width: "260px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "100px",
      align: "center",
    },
  ].filter(Boolean);

  const bodyList = Array.isArray(customers?.data)
    ? customers?.data?.map((v, i) => ({
        ...v,
        no: <Typography align="center">{pagi?.skip + i + 1}</Typography>,
        fullName: (
          <Box>
            <Typography
              align="center"
              variant="body1"
            >
              {v?.fullName}
            </Typography>
            <Typography
              align="center"
              variant="body2"
              fontWeight="bold"
            >
              {v?.username}
            </Typography>
          </Box>
        ),
        detail: (
          <Box>
            <Typography variant="body1">{v?.warehouse?.name}</Typography>
            <Typography variant="body2">{v?.type ==='Sales' ? getTypeDisplayName(v) : getRoleDisplayName(v?.role)}</Typography>
          </Box>
        ),
        contact: (
          <Box>
            <Typography variant="body1">{v?.phone}</Typography>
            <Typography variant="body2">{v?.email}</Typography>
          </Box>
        ),
      }))
    : [];

  const sortData = ["no", "fullName", isSalesTab ? null : "detail", "contact"].filter(Boolean);
  return {
    header,
    sortData,
    bodyList,
    isLoading,
    error,
    setPagi,
    pagi,
    total: customers?.count,
  };
}
